module.exports = __webpack_public_path__ + "static/media/event_approval_black.50665e72.svg";